import React, { useState, useRef, useEffect } from "react";
import Header from "../../dashboard/header";
import { Link } from "react-router-dom";
import { Table, Modal, Button } from "react-bootstrap";
import {
  FaWhatsapp, FaFacebook, FaFacebookMessenger,
  FaEllipsisV,
  FaShareAlt,
  FaEye,
  FaCheck,
  FaBan,
  FaClock,
  FaSortAmountUp,
  FaSortAmountDown,
  FaEdit,
  FaTrash,
  FaPlus,
  FaBoxes,
  FaThumbsUp,
  FaExclamationCircle,
  FaCalculator,
  FaFileAlt,
  FaCheckCircle,
} from "react-icons/fa";
import { createPortal } from "react-dom";
import Navbar from "../../dashboard/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Sidebar from "../../dashboard/sidebar";
import useAuth from "../../dashboard/useAuth";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Liste_produit = ({ titre }) => {
  useAuth();
  const [produits, setProduits] = useState([]);
  const [produitData, setProduitData] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [selectedProduit, setSelectedProduit] = useState(null);
  const [filtreTypePaiement, setFiltreTypePaiement] = useState("tous"); // 'tous', 'unique', 'abonnement'
  const [paiementType, setPaiementType] = useState("unique"); // 'unique' ou 'abonnement'
  const [prixMensuel, setPrixMensuel] = useState("");
  const [prixAnnuel, setPrixAnnuel] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "ascending",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [menu, setMenu] = useState(null);
  const menuRef = useRef(null);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const location = useLocation();
  const [descriptionOverflows, setDescriptionOverflows] = useState({});
  const [categories, setCategories] = useState([]); // Pour la liste des catégories
  const [selectedCategory, setSelectedCategory] = useState(""); // Pour la catégorie sélectionnée
  const [showAddModal, setShowAddModal] = useState(false);
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [prix, setPrix] = useState("");
  const [statut, setStatut] = useState("actif");
  const [type, setType] = useState("article");
  const [photo, setPhoto] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");

  const user_id = localStorage.getItem("IDDDD");
  const navigate = useNavigate();

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "PayMe | Produit"; // Définit le titre de la page
    }
  }, [user_id]);

  const fetchProduits = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_HOTE + "/liste-produit/"
      );
      if (response.ok) {
        const data = await response.json();
        setProduits(data); // Ne transformez pas les données ici
      } else {
        console.error("Erreur lors de la récupération des produits");
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
    }
  };

  useEffect(() => {
    fetchProduits();
  }, []);

  useEffect(() => {
    if (!showShareModal) {
      setQrCodeData(""); // Réinitialiser quand le modal est fermé
    }
  }, [showShareModal]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE + "/liste-categorie/"
        );
        if (response.ok) {
          const data = await response.json();
          setCategories(data); // Stocke le tableau des catégories
        } else {
          console.error("Erreur lors de la récupération des catégories");
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      }
    };

    fetchCategories();
  }, []);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: "", type: "" });
      fetchProduits();
    }, 3000);
  };

  const handleRowClick = (produit) => {
    setSelectedProduit(produit);
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "-";
    // Supprime tous les caractères non numériques
    const cleaned = phone.replace(/\D/g, '');
    // Format selon la longueur
    if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
    }
    return phone; // Retourne le numéro original si le format n'est pas reconnu
  };

  const menuStyle = {
    position: "absolute",
    backgroundColor: "white",
    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    borderRadius: "4px",
    zIndex: 1000,
    minWidth: "150px",
    border: "1px solid #ddd",
    padding: "5px 0",
    right: "auto", // S'assure qu'il n'y a pas de position right
    left: 0, // Positionné à gauche
  };

  const menuItemStyle = {
    padding: "8px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    ":hover": {
      backgroundColor: "#f5f5f5",
    },
  };
  const handleClick = (event, produit) => {
    event.stopPropagation();

    if (menu?.produit?.id === produit.id) {
      setMenu(null);
      return;
    }

    const buttonRect = event.currentTarget.getBoundingClientRect();

    setMenu({
      produit,
      x: buttonRect.left + window.scrollX, // Ajoutez le défilement horizontal
      y: buttonRect.bottom + window.scrollY, // Ajoutez le défilement vertical
    });
  };

  const closeMenu = () => setMenu(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isActionButton = event.target.closest(".action-button");
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !isActionButton
      ) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menu]);

  const handleDeleteProduit = async () => {
    if (selectedProduit) {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE +
          `/supprimer-produit/${selectedProduit.id}/`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          // Mettre à jour la liste des produits localement
          setProduits(
            produits.filter((produit) => produit.id !== selectedProduit.id)
          );

          // Stocker le message de succès dans le localStorage avant la redirection
          showAlert("Produit supprimé avec succès !");
        } else {
          console.error("Erreur lors de la suppression du produit");
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      } finally {
        setShowDeleteModal(false);
        setSelectedProduit(null);
      }
    }
  };

  const checkDescriptionOverflow = (produits) => {
    produits.forEach((produit) => {
      const element = document.getElementById(`description-${produit.id}`);
      if (element) {
        setDescriptionOverflows((prev) => ({
          ...prev,
          [produit.id]: element.scrollHeight > element.clientHeight,
        }));
      }
    });
  };

  useEffect(() => {
    checkDescriptionOverflow(produits);
  }, [produits]);

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleActiverProduit = async () => {
    if (selectedProduit) {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE +
          `/activer-desactiver-produit/${selectedProduit.id}/`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const updatedProduit = await response.json();

          // Mettre à jour la liste des produits localement
          setProduits(
            produits.map((produit) =>
              produit.id === updatedProduit.id ? updatedProduit : produit
            )
          );

          // Stocker le message dans le localStorage avant la redirection
          showAlert("Statut du produit changé avec succès !");
        } else {
          console.error("Erreur lors de la mise à jour du statut du produit");
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      }
    }
  };

  // Utiliser useEffect pour récupérer et afficher le message après redirection
  useEffect(() => {
    const successMessage = localStorage.getItem("successMessage");
    if (successMessage) {
      // Afficher le message (par exemple via une alerte ou un composant de notification)
      showAlert(successMessage);

      // Supprimer le message du localStorage après l'affichage
      localStorage.removeItem("successMessage");
    }
  }, []);

  const filteredProduits = produits.filter((produit) => {
    // Filtre par type de paiement
    if (
      filtreTypePaiement !== "tous" &&
      produit.type_paiement !== filtreTypePaiement
    ) {
      return false;
    }

    // Filtre par recherche (votre logique existante)
    return (
      produit.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      produit.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      produit.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase()) ||
      produit.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      produit.prix.toString().includes(searchTerm.toLowerCase()) ||
      produit.numero_paiement.toString().includes(searchTerm.toLowerCase()) ||
      (produit.prix_mensuel &&
        produit.prix_mensuel.toString().includes(searchTerm.toLowerCase())) ||
      (produit.prix_annuel &&
        produit.prix_annuel.toString().includes(searchTerm.toLowerCase())) ||
      produit.statut.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (produit.categorie &&
        produit.categorie.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  });

  const sortedProduits = [...filteredProduits].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = sortedProduits.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );
  const totalPages = Math.ceil(sortedProduits.length / itemsPerPage);
  const totalItems = produits.length; // Si 'formationList' contient toutes les formations

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleToggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleModifier = (produit) => {
    if (produit) {
      setProduitData({
        id: produit.id,
        nom: produit.nom,
        description: produit.description,
        type: produit.type || "article",
        paiement_type: produit.type_paiement || "unique",
        prix: produit.prix,
        prix_mensuel: produit.prix_mensuel || "",
        prix_annuel: produit.prix_annuel || "",
        statut: produit.statut || "actif",
        categorie: produit.categorie?.id?.toString() || produit.categorie_id?.toString() || "",
        photo_url: produit.photo_url,
        numero_paiement: produit.numero_paiement || "",
      });
      setShowEditModal(true);
    }
  };

  const [accesGroupe, setAccesGroupe] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem("groupe");

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupe(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                    .replace(/[\[\]']/g, "")
                    .trim()
                    .split(",")
                    .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupe(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);

  useEffect(() => {
    setCurrentPage(1); // Réinitialiser à la première page quand le filtre change
  }, [filtreTypePaiement]);

  if (!accesGroupe.includes("Produits")) {
    return null;
  }

  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]);
  };

  const handleCancel = () => {
    setNom("");
    setDescription("");
    setPrix("");
    setType("article");
    setStatut("actif");
    setSelectedCategory("");
    setPhoto(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation des champs obligatoires communs
    if (!nom || !description || !selectedCategory || !statut || !photo) {
      showAlert("Veuillez remplir tous les champs obligatoires", "error");
      return;
    }

    // Validation spécifique au type de paiement
    if (paiementType === "unique") {
      if (!prix) {
        showAlert("Veuillez entrer un prix pour le paiement unique", "error");
        return;
      }
    } else if (paiementType === "abonnement") {
      if (!prixMensuel && !prixAnnuel) {
        showAlert(
          "Veuillez entrer au moins un prix (mensuel ou annuel) pour l'abonnement",
          "error"
        );
        return;
      }
    }

    // Préparation des données
    const formData = new FormData();
    formData.append("nom", nom);
    formData.append("description", description);
    formData.append("type", type);
    formData.append("paiement_type", paiementType);
    formData.append("numero_paiement", phoneNumber);

    if (paiementType === "unique") {
      formData.append("prix", prix);
      formData.append("prix_mensuel", "0");
      formData.append("prix_annuel", "0");
    } else {
      formData.append("prix", "0");
      formData.append("prix_mensuel", prixMensuel || "0"); // Si vide, mettre 0
      formData.append("prix_annuel", prixAnnuel || "0"); // Si vide, mettre 0
    }

    formData.append("categorie_id", selectedCategory);
    formData.append("statut", statut);
    formData.append("photo", photo);

    try {
      // Envoi des données à l'API
      const response = await axios.post(
        `${process.env.REACT_APP_HOTE}/ajouter-produit/${user_id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        showAlert("Produit ajouté avec succès!", "success");
        // Réinitialisation du formulaire
        setNom("");
        setDescription("");
        setType("article");
        setPaiementType("unique");
        setPrix("");
        setPrixMensuel("");
        setPrixAnnuel("");
        setSelectedCategory("");
        setStatut("actif");
        setPhoto(null);
        handleCloseAddModal();
        fetchProduits(); // Recharger la liste des produits
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du produit:", error);
      showAlert(
        error.response?.data?.message || "Erreur lors de l'ajout du produit",
        "error"
      );
    }
  };

  const MenuItem = ({ icon, color, label, onClick }) => (
    <li className="context-menu-item" onClick={onClick}>
      <span className="context-menu-icon" style={{ color }}>
        {icon}
      </span>
      <span>{label}</span>
    </li>
  );

  const handleCloseEditModal = () => setShowEditModal(false);

  const handleEditReset = () => {
    if (selectedProduit) {
      setProduitData({
        id: selectedProduit.id,
        nom: selectedProduit.nom,
        description: selectedProduit.description,
        type: selectedProduit.type,
        prix: selectedProduit.prix,
        statut: selectedProduit.statut,
        categorie: selectedProduit.categorie,
        photo: selectedProduit.photo,
      });
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("nom", produitData.nom);
    formData.append("description", produitData.description);
    formData.append("type", produitData.type);
    formData.append("paiement_type", produitData.paiement_type);
    formData.append("numero_paiement", produitData.numero_paiement || "");

    if (produitData.paiement_type === "unique") {
      formData.append("prix", produitData.prix);
      formData.append("prix_mensuel", "0");
      formData.append("prix_annuel", "0");
    } else {
      formData.append("prix", "0");
      formData.append("prix_mensuel", produitData.prix_mensuel || "0");
      formData.append("prix_annuel", produitData.prix_annuel || "0");
    }

    formData.append("categorie_id", produitData.categorie);
    formData.append("statut", produitData.statut);

    if (photo) {
      formData.append("photo", photo);
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_HOTE}/modifier-produit/${produitData.id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Réponse:", response.data);
      await fetchProduits();
      showAlert("Modification réussie !");
      handleCloseEditModal();
    } catch (error) {
      console.error("Erreur:", error.response?.data || error.message);
      showAlert(
        error.response?.data?.message || "Échec de la modification",
        "danger"
      );
    }
  };

  const handleShareClick = async (produit) => {
    setQrCodeData(""); // Réinitialiser le QR code avant de charger le nouveau
    setSelectedProduit(produit); // S'assurer que le bon produit est sélectionné

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOTE}/produit-info/${produit.id}/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setQrCodeData(response.data.qr_code_url || window.location.href);
      setShowShareModal(true);
    } catch (error) {
      console.error("Erreur lors de la récupération du QR code:", error);
      setQrCodeData(window.location.href);
      setShowShareModal(true);
    }
  };


  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex align-items-center">
                <FaBoxes size={25} className="mr-2" /> Gestion des Produits
              </h2>
              <small>Administration des produits.</small>

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <Link to={`/admin`}> Administration</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <small> Produits</small>
                  </li>
                </ol>
              </small>
            </div>
          </div>
          {/* <Header titre="Produits" sous_titre="Dashboard"  sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Produits" user_id={user_id} /> */}
          <div className=" mt-3">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              <h5>Liste des produits</h5>
              <div
                className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0"
                style={{ gap: "10px" }}
              >
                <div className="d-flex">
                  <button
                    onClick={handleShowAddModal}
                    className="btn btn-success mr-2"
                  >
                    <FaPlus /> Ajouter
                  </button>
                </div>
              </div>
            </div>

            {alert.message && (
              <div className={`alert alert-${alert.type}`}>{alert.message}</div>
            )}

            <div className="row">
              <div className="col-lg-12">
                <div className="ibox">
                  <div className="ibox-content">
                    <div
                      className="d-flex justify-content-between align-items-center mb-3"
                      style={{ gap: "10px" }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <select
                          id="itemsPerPage"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                          className="form-select bg-default p-1"
                          style={{
                            width: "auto",
                            border: "1px black solid",
                            borderRadius: "5px",
                          }}
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </select>

                        <select
                          value={filtreTypePaiement}
                          onChange={(e) =>
                            setFiltreTypePaiement(e.target.value)
                          }
                          className="form-select bg-default p-1"
                          style={{
                            width: "auto",
                            border: "1px black solid",
                            borderRadius: "5px",
                          }}
                        >
                          <option value="tous">Tous les types</option>
                          <option value="unique">Paiement unique</option>
                          <option value="abonnement">Abonnement</option>
                        </select>
                      </div>

                      <input
                        type="text"
                        placeholder="Rechercher..."
                        className="form-control"
                        style={{ maxWidth: "150px", width: "100%" }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    <div className="table-responsive">
                      <table
                        className="footable table table-stripped footable-loaded tablet breakpoint"
                        data-page-size="8"
                        data-filter="#filter"
                        style={{ fontSize: "11px" }}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell"
                              onClick={() => handleSort("nom")}
                              style={{ width: "15%", minWidth: "100px" }}
                            >
                              Nom
                              {sortConfig.key === "nom"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              onClick={() => handleSort("description")}
                              style={{ width: "20%", minWidth: "150px" }}
                            >
                              Description
                              {sortConfig.key === "description"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              onClick={() => handleSort("type")}
                              style={{ width: "15%", minWidth: "80px" }}
                            >
                              Type
                              {sortConfig.key === "type"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            {filtreTypePaiement !== "abonnement" && (
                              <th
                                className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                onClick={() => handleSort("prix")}
                                style={{ width: "8%", minWidth: "70px" }}
                              >
                                Prix
                                {sortConfig.key === "prix"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                              </th>
                            )}

                            {filtreTypePaiement !== "unique" && (
                              <>
                                <th
                                  className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                  onClick={() => handleSort("prix_mensuel")}
                                  style={{ width: "8%", minWidth: "70px" }}
                                >
                                  Mensuel
                                  {sortConfig.key === "prix_mensuel"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                </th>
                                <th
                                  className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                  onClick={() => handleSort("prix_annuel")}
                                  style={{ width: "8%", minWidth: "70px" }}
                                >
                                  Annuel
                                  {sortConfig.key === "prix_annuel"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                </th>
                              </>
                            )}
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              onClick={() => handleSort("categorie")}
                              style={{ width: "10%", minWidth: "80px" }}
                            >
                              Catégorie
                              {sortConfig.key === "categorie"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              onClick={() => handleSort("statut")}
                              style={{ width: "8%", minWidth: "80px" }}
                            >
                              Statut
                              {sortConfig.key === "statut"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              onClick={() => handleSort("numero_paiement")}
                              style={{ width: "12%", minWidth: "100px" }}
                            >
                              Numéro
                              {sortConfig.key === "numero_paiement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap text-center d-none d-md-table-cell"
                              onClick={() => handleSort("ajoute_par")}
                              style={{ width: "15%", minWidth: "100px" }}
                            >
                              Ajouté par
                              {sortConfig.key === "ajoute_par"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                              style={{ width: "5%", minWidth: "50px" }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentProducts.map((produit) => {
                            return (
                              <tr
                                key={produit.id}
                                className="bg-white" // Supprimez la classe conditionnelle
                              >
                                <td style={{ padding: "0.5rem" }}>
                                  <div className="fw-semibold">
                                    {produit.nom}
                                  </div>
                                  <div
                                    className="lesInfos"
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    <small className="text-muted d-block">
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            produit.description.substring(
                                              0,
                                              50
                                            ) +
                                            (produit.description.length > 50
                                              ? "..."
                                              : ""),
                                        }}
                                      ></span>
                                    </small>
                                  </div>
                                </td>
                                <td
                                  className="d-none d-md-table-cell align-middle"
                                  style={{
                                    position: "relative",
                                    padding: "0.5rem",
                                  }}
                                >
                                  <div
                                    id={`description-${produit.id}`}
                                    className={`description-text ${expandedDescriptions[produit.id]
                                      ? "expanded"
                                      : ""
                                      }`}
                                    style={{
                                      maxHeight: expandedDescriptions[
                                        produit.id
                                      ]
                                        ? "none"
                                        : "3em",
                                      overflow: "hidden",
                                      whiteSpace: "pre-wrap",
                                      fontSize: "0.85rem",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: produit.description,
                                    }}
                                  />
                                  {descriptionOverflows[produit.id] && (
                                    <button
                                      onClick={() =>
                                        handleToggleDescription(produit.id)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        color: "#6c757d",
                                        cursor: "pointer",
                                        padding: 0,
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      {expandedDescriptions[produit.id]
                                        ? "Voir moins"
                                        : "Voir plus..."}
                                    </button>
                                  )}
                                </td>
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <span className=" text-dark">
                                    {produit.type}
                                  </span>
                                </td>
                                {filtreTypePaiement !== "abonnement" && (
                                  <td
                                    className="d-none d-md-table-cell text-center align-middle"
                                    style={{ padding: "0.5rem" }}
                                  >
                                    {produit.prix ? (
                                        <span className="fw-semibold">
                                          {produit.prix} FCFA
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                  </td>
                                )}

                                {filtreTypePaiement !== "unique" && (
                                  <>
                                    <td
                                      className="d-none d-md-table-cell text-center align-middle"
                                      style={{ padding: "0.5rem" }}
                                    >
                                      {produit.prix_mensuel ? (
                                        <span className="fw-semibold">
                                          {produit.prix_mensuel} FCFA
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td
                                      className="d-none d-md-table-cell text-center align-middle"
                                      style={{ padding: "0.5rem" }}
                                    >
                                      {produit.prix_annuel ? (
                                        <span className="fw-semibold">
                                          {produit.prix_annuel} FCFA
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  </>
                                )}
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <span>
                                    {produit.categorie?.nom || produit.categorie}
                                  </span>
                                </td>
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <span
                                    className={`badge ${produit.statut === "actif"
                                      ? "bg-success"
                                      : produit.statut === "inactif"
                                        ? "bg-secondary"
                                        : produit.statut === "en attente"
                                          ? "bg-warning text-dark"
                                          : "bg-light text-dark"
                                      }`}
                                  >
                                    {produit.statut}
                                  </span>
                                </td>
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <span className="fw-semibold">
                                    {formatPhoneNumber(produit.numero_paiement) || "-"}
                                  </span>
                                </td>
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <span>{produit.ajoute_par}</span>
                                </td>
                                <td
                                  className="d-none d-md-table-cell text-center align-middle"
                                  style={{ padding: "0.5rem" }}
                                >
                                  <button
                                    onClick={(e) => handleClick(e, produit)}
                                    style={{
                                      borderRadius: "4px", // Border-radius légèrement augmenté
                                      width: "30px",
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      transition: "all 0.2s",
                                      margin: "0 auto" // Centrage horizontal
                                    }}
                                    className={`btn btn-sm btn-gray action-button ${menu?.produit?.id === produit.id
                                      ? "active"
                                      : ""
                                      }`}
                                    aria-label="Actions"
                                  >
                                    <FaEllipsisV className="icon" />
                                  </button>
                                </td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {menu && createPortal(
                        <div
                          ref={menuRef}
                          className="context-menu"
                          style={{
                            ...menuStyle,
                            top: `${menu.y}px`,
                            left: `${menu.x}px`,
                            transform: "translateX(-90%)",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <ul className="context-menu-list">
                            <MenuItem
                              icon={<FaEdit />}
                              color="#117cf5"
                              label="Modifier"
                              onClick={() => {
                                setSelectedProduit(menu.produit);
                                handleModifier(menu.produit);
                                closeMenu();
                              }}
                            />
                            <MenuItem
                              icon={<FaShareAlt />}
                              color="#fd7e14"
                              label="Partager"
                              onClick={() => {
                                handleShareClick(menu.produit);
                                closeMenu();
                              }}
                            />
                            <MenuItem
                              icon={menu.produit.statut === "actif" ? <FaBan /> : <FaCheck />}
                              color={menu.produit.statut === "actif" ? "#dc3545" : "#28a745"}
                              label={menu.produit.statut === "actif" ? "Désactiver" : "Activer"}
                              onClick={() => {
                                setSelectedProduit(menu.produit);
                                handleActiverProduit();
                                closeMenu();
                              }}
                            />
                            <MenuItem
                              icon={<FaTrash />}
                              color="#dc3545"
                              label="Supprimer"
                              onClick={() => {
                                setSelectedProduit(menu.produit);
                                handleShowDeleteModal();
                                closeMenu();
                              }}
                            />
                          </ul>
                        </div>,
                        document.body
                      )}
                    </div>
                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      {/* Information about the number of entries */}
                      {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                {`Élément ${currentPage === 1 ? 1 : (currentPage - 1) * itemsPerPage + 1} à ${currentPage * itemsPerPage > totalItems ? totalItems : currentPage * itemsPerPage
                                                    } sur ${totalItems}`}
                                            </div> */}
                      <div
                        className="dataTables_info"
                        role="status"
                        aria-live="polite"
                      >
                        {totalItems === 0
                          ? "Aucun élément à afficher"
                          : `Élément ${currentPage === 1
                            ? 1
                            : (currentPage - 1) * itemsPerPage + 1
                          } à ${currentPage * itemsPerPage > totalItems
                            ? totalItems
                            : currentPage * itemsPerPage
                          } sur ${totalItems}`}
                      </div>

                      <div>
                        {Array.from({ length: totalPages }, (_, index) => (
                          <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`btn ${currentPage === index + 1
                              ? "btn-default"
                              : "btn-light"
                              } mx-1`}
                          >
                            {index + 1}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal d'ajout de produit */}
            <Modal show={showAddModal} onHide={handleCloseAddModal} size="100%">
              <Modal.Header>
                <Modal.Title>Ajouter un produit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form
                  className="m-t"
                  role="form"
                  onSubmit={handleSubmit}
                  encType="multipart/form-data"
                >
                  <div className="form-group">
                    <label>Nom*</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Entrez le nom"
                      required
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Description*</label>
                    <ReactQuill
                      theme="snow"
                      value={description}
                      onChange={setDescription}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline", "strike"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                      style={{ height: "200px", marginBottom: "80px" }}
                      className="custom-quill-editor"
                    />
                  </div>
                  <div className="form-group">
                    <label>Type*</label>
                    <select
                      className="form-control m-b"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="article">Article</option>
                      <option value="service">Service</option>
                    </select>
                  </div>

                  {/* Nouveaux champs pour le type de paiement */}
                  <div className="form-group">
                    <label>Type de paiement*</label>
                    <div className="d-flex align-items-center mb-3">
                      <div className="form-check mr-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="paiementUnique"
                          checked={paiementType === "unique"}
                          onChange={() => setPaiementType("unique")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="paiementUnique"
                        >
                          Paiement unique
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="abonnement"
                          checked={paiementType === "abonnement"}
                          onChange={() => setPaiementType("abonnement")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="abonnement"
                        >
                          Abonnement
                        </label>
                      </div>
                    </div>
                  </div>

                 {/* Champ prix conditionnel */}
                  {paiementType === "unique" && (
                    <div className="form-group">
                      <label>Prix*</label>
                      <input
                        type="text"  // Changé de "number" à "text" pour mieux contrôler l'input
                        className="form-control"
                        placeholder="Entrez le prix"
                        required
                        value={prix}
                        onChange={(e) => {
                          // Autorise uniquement les chiffres et un point décimal
                          const value = e.target.value.replace(/[^0-9.]/g, '');
                          // Vérifie qu'il n'y a qu'un seul point décimal
                          const parts = value.split('.');
                          const sanitizedValue = parts.length > 2
                            ? parts[0] + (parts[1] ? '.' + parts[1] : '')
                            : value;
                          setPrix(sanitizedValue);
                        }}
                        onKeyDown={(e) => {
                          // Empêche tous les caractères non numériques sauf Backspace, Delete, Tab, etc.
                          if (!/[0-9.]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  )}

                  {paiementType === "abonnement" && (
                    <>
                      <div className="form-group">
                        <label>Prix mensuel*</label>
                        <input
                          type="text"  // Changé de "number" à "text" pour mieux contrôler l'input
                          className="form-control"
                          placeholder="Entrez le prix mensuel"
                          required
                          value={prixMensuel}
                          onChange={(e) => {
                            // Autorise uniquement les chiffres et un point décimal
                            const value = e.target.value.replace(/[^0-9.]/g, '');
                            // Vérifie qu'il n'y a qu'un seul point décimal
                            const parts = value.split('.');
                            const sanitizedValue = parts.length > 2
                              ? parts[0] + (parts[1] ? '.' + parts[1] : '')
                              : value;
                            setPrixMensuel(sanitizedValue);
                          }}
                          onKeyDown={(e) => {
                            // Empêche tous les caractères non numériques sauf Backspace, Delete, Tab, etc.
                            if (!/[0-9.]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />

                      </div>
                      <div className="form-group">
                        <label>Prix annuel*</label>
                        <input
                          type="text"  // Changé de "number" à "text" pour mieux contrôler l'input
                          className="form-control"
                          placeholder="Entrez le prix annuel"
                          required
                          value={prixAnnuel}
                          onChange={(e) => {
                            // Autorise uniquement les chiffres et un point décimal
                            const value = e.target.value.replace(/[^0-9.]/g, '');
                            // Vérifie qu'il n'y a qu'un seul point décimal
                            const parts = value.split('.');
                            const sanitizedValue = parts.length > 2
                              ? parts[0] + (parts[1] ? '.' + parts[1] : '')
                              : value;
                            setPrixAnnuel(sanitizedValue);
                          }}
                          onKeyDown={(e) => {
                            // Empêche tous les caractères non numériques sauf Backspace, Delete, Tab, etc.
                            if (!/[0-9.]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />

                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label>Catégorie*</label>
                    <select
                      className="form-control m-b"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      required
                    >
                      <option value="">Choisir une catégorie</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Statut*</label>
                    <select
                      className="form-control m-b"
                      value={statut}
                      onChange={(e) => setStatut(e.target.value)}
                    >
                      <option value="inactif">Inactif</option>
                      <option value="actif">Actif</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Photo*</label>
                    <input
                      type="file"
                      className="form-control"
                      required
                      onChange={handleFileChange}
                      accept="image/*"
                    />
                  </div>
                  <div className="form-group">
                    <label>Numéro de paiement</label>
                    <div className="phone-input-wrapper">
                      <PhoneInput
                        international
                        defaultCountry="FR"
                        value={phoneNumber}
                        onChange={setPhoneNumber}
                        inputStyle={{
                          width: "100%",
                          height: "38px",
                          border: "none",
                          padding: "6px 12px",
                          paddingLeft: "70px",
                        }}
                        buttonStyle={{
                          border: "none",
                          background: "#f0f0f0",
                          paddingLeft: "8px",
                          height: "100%",
                        }}
                      />
                    </div>
                  </div>

                  <style>{`
  .phone-input-wrapper {
    border: 1px solid #ced4da;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .phone-input-wrapper:focus-within {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  /* Style spécifique pour agrandir le drapeau */
  .flag-dropdown {
    height: 100%;
  }
  .selected-flag {
    height: 100%;
    padding: 0 8px;
  }
  .selected-flag .flag {
    transform: scale(1.4); /* Agrandit le drapeau de 30% */
    margin-right: 5px;
  }
`}</style>
                  <div className="text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-default mr-2"
                      onClick={handleCloseAddModal}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-success">
                      Enregistrer
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </Modal>

            {/* Modal de modification de produit */}
            <Modal show={showEditModal} onHide={handleCloseEditModal} size="100%">
              <Modal.Header>
                <Modal.Title>Modifier le produit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form className="m-t" role="form" onSubmit={handleEditSubmit} encType="multipart/form-data">
                  <div className="form-group">
                    <label>Nom*</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Entrez le nom"
                      required
                      value={produitData.nom}
                      onChange={(e) =>
                        setProduitData({
                          ...produitData,
                          nom: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Description*</label>
                    <ReactQuill
                      theme="snow"
                      value={produitData.description}
                      onChange={(value) =>
                        setProduitData({ ...produitData, description: value })
                      }
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline", "strike"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                      style={{ height: "200px", marginBottom: "80px" }}
                      className="custom-quill-editor"
                    />
                  </div>
                  <div className="form-group">
                    <label>Type*</label>
                    <select
                      className="form-control m-b"
                      value={produitData.type || "article"}
                      onChange={(e) =>
                        setProduitData({
                          ...produitData,
                          type: e.target.value,
                        })
                      }
                    >
                      <option value="article">Article</option>
                      <option value="service">Service</option>
                    </select>
                  </div>

                  {/* Type de paiement */}
                  <div className="form-group">
                    <label>Type de paiement*</label>
                    <div className="d-flex align-items-center mb-3">
                      <div className="form-check mr-4">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="paiementUniqueEdit"
                          checked={produitData.paiement_type === "unique"}
                          onChange={() =>
                            setProduitData({
                              ...produitData,
                              paiement_type: "unique"
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor="paiementUniqueEdit">
                          Paiement unique
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="abonnementEdit"
                          checked={produitData.paiement_type === "abonnement"}
                          onChange={() =>
                            setProduitData({
                              ...produitData,
                              paiement_type: "abonnement"
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor="abonnementEdit">
                          Abonnement
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Champ prix conditionnel */}
                  {produitData.paiement_type === "unique" ? (
                    <div className="form-group">
                      <label>Prix*</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Entrez le prix"
                        required
                        value={produitData.prix}
                        onChange={(e) =>
                          setProduitData({
                            ...produitData,
                            prix: e.target.value,
                          })
                        }
                      />
                    </div>
                  ) : (
                    <>
                      <div className="form-group">
                        <label>Prix mensuel*</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          placeholder="Entrez le prix mensuel"
                          required
                          value={produitData.prix_mensuel}
                          onChange={(e) =>
                            setProduitData({
                              ...produitData,
                              prix_mensuel: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Prix annuel*</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          placeholder="Entrez le prix annuel"
                          required
                          value={produitData.prix_annuel}
                          onChange={(e) =>
                            setProduitData({
                              ...produitData,
                              prix_annuel: e.target.value,
                            })
                          }
                        />
                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label>Catégorie*</label>
                    <select
                      className="form-control m-b"
                      value={produitData.categorie || ""}
                      onChange={(e) =>
                        setProduitData({
                          ...produitData,
                          categorie: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Choisir une catégorie</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id.toString()}>
                          {cat.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Statut*</label>
                    <select
                      className="form-control m-b"
                      value={produitData.statut || "actif"}
                      onChange={(e) =>
                        setProduitData({
                          ...produitData,
                          statut: e.target.value,
                        })
                      }
                    >
                      <option value="inactif">Inactif</option>
                      <option value="actif">Actif</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                      accept="image/*"
                    />
                    {produitData.photo_url && (
                      <div className="mt-2">
                        <small>Photo actuelle :</small>
                        <img
                          src={produitData.photo_url.startsWith('http')
                            ? produitData.photo_url
                            : `${process.env.REACT_APP_HOTE}${produitData.photo_url}`}
                          alt={`Photo de ${produitData.nom}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            display: "block",
                            marginTop: "5px",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "chemin/vers/image/par-defaut.jpg";
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Numéro de paiement</label>
                    <div className="phone-input-wrapper">
                      <PhoneInput
                        international
                        defaultCountry="FR"
                        value={produitData.numero_paiement || ""}
                        onChange={(value) =>
                          setProduitData({
                            ...produitData,
                            numero_paiement: value,
                          })
                        }
                        inputStyle={{
                          width: "100%",
                          height: "38px",
                          border: "none",
                          padding: "6px 12px",
                          paddingLeft: "70px",
                        }}
                        buttonStyle={{
                          border: "none",
                          background: "#f0f0f0",
                          paddingLeft: "8px",
                          height: "100%",
                        }}
                      />
                    </div>
                  </div>

                  <style>{`
        .phone-input-wrapper {
          border: 1px solid #ced4da;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        .phone-input-wrapper:focus-within {
          border-color: #80bdff;
          outline: 0;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
        .flag-dropdown {
          height: 100%;
        }
        .selected-flag {
          height: 100%;
          padding: 0 8px;
        }
        .selected-flag .flag {
          transform: scale(1.4);
          margin-right: 5px;
        }
      `}</style>

                  <div className="text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-default mr-2"
                      onClick={handleCloseEditModal}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-success">
                      Enregistrer
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </Modal>


            {/* Modal de partage */}
            <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
              <Modal.Body className="text-center mx-0 pb-4 pt-0">
                <div className="mb-4 ml-0 mr-0">
                  <p className="text-muted mb-3">
                    Scannez le QR code ou partagez via les réseaux sociaux
                  </p>
                  <div className="bg-light p-3 rounded d-inline-block">
                    <img
                      src={qrCodeData}
                      alt="QR Code"
                      style={{ width: '180px', height: '180px' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext x='50%' y='50%' font-size='10' text-anchor='middle' dominant-baseline='middle'%3EQR Code non disponible%3C/text%3E%3C/svg%3E";
                      }}
                    />
                  </div>
                  {selectedProduit && (
                    <p className="text-muted mt-3 small">
                      {selectedProduit.nom} - {selectedProduit.prix?.toLocaleString() || '0'} FCFA
                    </p>
                  )}
                </div>

                <div className="d-flex justify-content-center gap-4 mt-4">
                  {/* Bouton WhatsApp */}
                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(
                      `Découvrez ce produit: ${selectedProduit?.nom || ''} - ${selectedProduit?.prix?.toLocaleString() || '0'} FCFA\n` +
                      `Lien: ${window.location.href}\n` +
                      `QR Code: ${qrCodeData}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#25D366',
                      color: 'white',
                      border: 'none',
                      margin: '0 1rem',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    }}
                  >
                    <FaWhatsapp size={26} />
                  </a>

                  {/* Bouton Facebook */}
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#1877F2',
                      color: 'white',
                      border: 'none',
                      margin: '0 1rem',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    }}
                  >
                    <FaFacebook size={26} />
                  </a>

                  {/* Bouton Messenger */}
                  <a
                    href={`fb-messenger://share/?link=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '50px',
                      height: '50px',
                      background: 'linear-gradient(135deg, #00B2FF, #A033FF, #FF5280)',
                      color: 'white',
                      border: 'none',
                      margin: '0 1rem',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                    }}
                  >
                    <FaFacebookMessenger size={26} />
                  </a>
                </div>
              </Modal.Body>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
              <Modal.Header>
                <Modal.Title>Confirmer la Suppression</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Êtes-vous sûr de vouloir supprimer le produit{" "}
                <strong>{selectedProduit?.nom}</strong> ?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                  Annuler
                </Button>
                <Button variant="success" onClick={handleDeleteProduit}>
                  Supprimer
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Liste_produit;
